import { GreenGraph } from '../../../assets/icons'
import NewsletterForm from '../../newsletter-forms'

import styles from './styles.module.scss'

export const StayInTheLoop = () => {
  return (
    <section className={styles['main-section']}>
      <div className={styles['content']}>
        <h2 className={styles['title']}>
          Stay in the <span className={styles['decoration']}>loop</span>
        </h2>
        <p className={styles['paragraph']}>International career content straight to your inbox</p>
        <NewsletterForm className={styles['form']} />
      </div>
      <GreenGraph className={styles['graph']} />
    </section>
  )
}

export default StayInTheLoop
